import {
    Platform,
    Linking
} from "react-native";
import type {
    CitationDomainConstantType,
    CitationDateConstantType,
    ISource
} from "./type";
import {
    formatDateTime
} from "../../helpers/locale";

const URL_HOST_PATTERN = /^[a-z][a-z0-9+.-]*:\/\/([^/?#:]+)/i;

const WWW_PREFIX_PATTERN = /^www\./i;

export const getSourceDomain = ({
    source
}: CitationDomainConstantType): string => {
    if(source.domain) {
        return source.domain;
    }

    const match = URL_HOST_PATTERN.exec(source.url);

    return match?.[1]?.replace(WWW_PREFIX_PATTERN, "") ?? source.url;
};

export const getSourceDate = ({
    locale,
    source
}: CitationDateConstantType): string => {
    if(source.date === undefined) {
        return "";
    }

    const date = source.date instanceof Date ? source.date : new Date(source.date);

    return formatDateTime({
        preset: "date",
        locale,
        date
    });
};

export const openSourceUrl = ({
    source
}: {
    source: ISource;
}): void => {
    if(Platform.OS === "web") {
        globalThis.open?.(source.url, "_blank", "noopener,noreferrer");

        return;
    }

    Linking.openURL(source.url).catch(() => undefined);
};
